import {REFRESH_ROBOT_BATTERIES_STARTED} from "../../../reducers/dashboardReducer";



export const refreshRobotBatteriesStarted = () =>{
    return {
        type: REFRESH_ROBOT_BATTERIES_STARTED
    }
}